<template>
  <div class="pulsating-ellipses">
    <svg class="svg" expanded="true" :height="size * 4" :width="size * 4" v-for="idx in num" :key="idx">
      <circle v-if="state === 'animate'" cx="50%" cy="50%" :r="dotSize" :style="dotStyle"></circle>
      <circle v-if="state === 'animate'" class="pulse" cx="50%" cy="50%" :r="size" :style="getPulseStyle(idx)"></circle>
      <circle v-if="state === 'delay'" cx="50%" cy="50%" :r="dotSize" :style="delayStyle"></circle>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'pulsating-ellipses',
  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    color: {
      type: String,
      default: 'black'
    },
    num: {
      type: Number,
      default: 3
    },
    dotSize: {
      type: Number,
      default: 1.5
    },
    pulseSizeMultiplier: {
      type: Number,
      default: 1.5
    }
  },
  computed: {
    size () {
      return this.dotSize * this.pulseSizeMultiplier
    },
    dotStyle () {
      return {
        stroke: this.color,
        fill: this.color
      }
    },
    delayStyle () {
      return {
        ...this.dotStyle,
        'animation-duration': `${this.delayBetweenIterations}ms`,
        'animation-delay': '0ms'
      }
    }
  },
  methods: {
    getPulseStyle (idx) {
      return {
        ...this.dotStyle,
        'animation-duration': `${this.animationDuration}ms`,
        'animation-delay': ((this.animationDuration / 3) / this.num) * idx + 'ms'
      }
    }
  },
  data () {
    return {
      task: null,
      state: 'animate'
    }
  },
  async mounted () {
    const startAnimation = () => {
      this.state = 'animate'
      if (this.delayBetweenIterations > 0) {
        this.task = setTimeout(startDelay, this.animationDuration + 1)
      }
    }
    const startDelay = () => {
      this.state = 'delay'
      this.task = setTimeout(startAnimation, this.delayBetweenIterations)
    }
    startAnimation()
  }
}
</script>

<style lang="scss" scoped>
.pulsating-ellipses {
  circle {
    stroke: black;
    stroke-width: 1px;
    stroke-opacity: 1;
  }

  .pulse {
    fill: white;
    fill-opacity: 0;
    transform-origin: 50% 50%;
    animation-name: pulse;
    animation-iteration-count: infinite;
  }

  @keyframes pulse {
    0%, 100% {
      stroke-width: 3px;
      stroke-opacity: 1;
      transform: scale(0.3);
    }

    50% {
      stroke-width: 0;
      stroke-opacity: 0;
      transform: scale(2);
    }
  }
}
</style>
